const alertTokens = ({ colors, borders }) => ({
  colors: {
    default: {
      positive: {
        bg: colors.positive.default,
        color: colors.neutral['0'],
      },
      informative: {
        bg: colors.informative.default,
        color: colors.neutral['0'],
      },
      warning: {
        bg: colors.warning.default,
        color: colors.neutral['0'],
      },
      negative: {
        bg: colors.negative.default,
        color: colors.neutral['0'],
      },
      neutral: {
        bg: colors.neutrals[60],
        color: colors.neutral['0'],
      },
      link: {
        color: colors.neutral['0'],
      },
    },
    soft: {
      positive: {
        bg: colors.positive.lightest,
        color: colors.positive.default,
      },
      informative: {
        bg: colors.informative.lightest,
        color: colors.informative.darkest,
      },
      warning: {
        bg: colors.warning.lightest,
        color: colors.warning.default,
      },
      negative: {
        bg: colors.negative.lightest,
        color: colors.negative.default,
      },
      neutral: {
        bg: colors.neutral['30'],
        color: colors.neutral['80'],
      },
      white: {
        bg: colors.neutral['0'],
        color: colors.neutral['50'],
      },
      link: {
        color: colors.informative.darkest,
      },
    },
  },
  borders: {
    link: {
      border: '1px dotted',
    },
    container: {
      border: borders[1],
    },
  },
});

export default alertTokens;
